import { isEmpty } from '../string'

export const invoiceOptions = {
  nonTW: null,
  noEInvoice: 0,
  eInvoice: 1,
  nonAutoFilled: ['Taiwan']
}

export const carrierTypes = {
  greenWorldEInvoice: 1,
  citizenDigitalCertificate: 2,
  cellphoneBarcode: 3
}

const isValidCellphoneBarcode = (str) => {
  if (typeof str !== 'string') return false
  return /^\/[a-zA-Z0-9+\-.]{7}$/.test(str)
}

const isValidCitizenDigitalCertificate = (str) => {
  if (typeof str !== 'string') return false
  return /^[A-Z]{2}[0-9]{14}$/.test(str)
}

const isNumericalStringOfLength8 = (str) => {
  if (typeof str !== 'string') return false
  return /^\d{8}$/.test(str)
}

export const getInvoiceError = ({
  t,
  unifiedBusinessNumber,
  carrierType: _carrierType,
  carrierNumber,
  organisationName
}) => {
  let errors = {}

  const { value: carrierType } = _carrierType || {}

  if (!isEmpty(unifiedBusinessNumber) || !isEmpty(organisationName)) {
    if (isEmpty(organisationName)) {
      errors.organisationName = t('This field is required.')
    }
    if (isEmpty(unifiedBusinessNumber)) {
      errors.unifiedBusinessNumber = t('This field is required.')
    }
    if (
      !isEmpty(unifiedBusinessNumber) &&
      !isNumericalStringOfLength8(unifiedBusinessNumber)
    ) {
      errors.unifiedBusinessNumber = t(
        'Invalid format. Please enter valid format e.g. 12345678'
      )
    }
  } else {
    switch (carrierType) {
      case carrierTypes.citizenDigitalCertificate:
        if (!carrierNumber) {
          errors.carrierNumber = t('This field is required.')
        } else if (!isValidCitizenDigitalCertificate(carrierNumber)) {
          errors.carrierNumber = t(
            'Please enter valid format e.g. TP03000001234567'
          )
        }
        break
      case carrierTypes.cellphoneBarcode:
        if (!carrierNumber) {
          errors.carrierNumber = t('This field is required.')
        } else if (!isValidCellphoneBarcode(carrierNumber)) {
          errors.carrierNumber = t(
            'Invalid format. Please enter valid format e.g. /AB201C9'
          )
        }
        break
    }
  }

  return errors
}
